/**
 * Created by fers on 05.02.16.
 */
import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import types from '../../common/model-api/types';
import Relay from 'react-relay';
import {FormattedMessage, FormattedHTMLMessage, injectIntl, defineMessages} from 'react-intl';
import ChannelIcon from '../channel-defs/ChannelIcon.react';
import {callGrant} from './ChannelGranted.react';
import urlMapping from '../app/URLMapping';
import LoadingButton from '../fw/LoadingButton.react';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import ScenarioBoxAsWizard from '../scenarios/ScenarioBoxAsWizard.react';
import ScenarioIcon from '../scenarios/ScenarioIcon.react';
import "../scenarios/Scenario.scss";
import ScenarioWizard from '../scenarios/ScenarioWizard.react';
import * as Tool from '../fw/Tool';
import config from '../../common/config';
import {getLocale} from '../locales';
import EventTracker from '../app/EventTracker';
import {AUTH_TYPE_PER_USER} from "../../common/model-api/ChannelDefType";
import {safeJSONparse} from "../../common/util/safeJSONparse";
import AgentLink from '../fw/AgentLink.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';

const messages = defineMessages({
    title: {id: 'channelAddStep3.title', 'defaultMessage': 'Editing application'}
});

class ChannelAddStep3 extends React.Component {

    static propTypes = {
		cancel: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
		createCallback: PropTypes.func,
        intl: PropTypes.object.isRequired,
		loadingStopFn: PropTypes.func,
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
		wrapper: PropTypes.bool
    };

	static defaultProps = {
		wrapper: false
	};

    static contextTypes = {
        router: PropTypes.object
    };

    typeName = 'channels';

	constructor(props) {
		super(props);

		this.state = {
			showContent: false
		};
	}

    _create = () => {
        const channel = this.props.user.organisation.channel;
        const scenario = this.props.user.scenario;

        EventTracker.trackEvent(EventTracker.EVENT_CLICKS, {
            event: 'channel-grant',
            type: 'application'
        }, true);

        let metadata = safeJSONparse(channel.channelDef.metadata);

        return callGrant(channel, scenario, metadata.grantType, this.props.relay);
    };

    componentDidMount() {
        const {channel} = this.props.user.organisation;

        if (channel) {
            let metadata = safeJSONparse(channel.channelDef.metadata);
            /* if channel has no grant, skip to next step */
            if (!metadata.hasGrant) {
                let args = {
                    id: channel['id'],
                    organisation_id: this.props.user.organisation['realId']
                };

                /* are we creating this channel as part of scenario? */
                let scenarioPrefix = "";
                if (this.props.user.scenario) {
                    args['scenario_id'] = this.props.user.scenario['realId'];
					args.urlFragment = this.props.user.scenario.urlFragment;
                    scenarioPrefix = "scenario-";
                }

				if (this.props.createCallback) {
					this.props.createCallback(channel);
				}
                else if (channel.activated) {
                    if (this.props.user.scenario) {
                        let path = urlMapping.getUrl(types['channels'], scenarioPrefix + "apply", args);
                        this.context.router.push(path);
                    } else {
                        let path = urlMapping.getUrl(types['channels'], "view", args);
                        this.context.router.push(path);
                    }
                } else {
                    let path = urlMapping.getUrl(types['channels'], scenarioPrefix + "create-step-5", args);
                    this.context.router.push(path);
                }
            }
			else {
				this.showContent();
			}
        }
		else {
			this.showContent();
		}
    }

	showContent() {
		setTimeout(() => {
			this.setState({
				showContent: true
			});
		});
	}

    render() {
        const {channel} = this.props.user.organisation;
        let channelDef = channel.channelDef;
        let type = types['channelDefs'];

        let connectRequirement = null;
        if (channelDef.connectRequirement) {
            connectRequirement = Tool.getFormatted(type, 'connectRequirement', this.props.intl.formatMessage, channelDef);
        }
        if (channelDef.requiresAgent) {
            connectRequirement = (<span><FormattedMessage defaultMessage="Requires installation of {agentLink}." id="channelDef.requiresAgentUrl" values={{
                productName: config.PRODUCT_NAME,
                agentLink: <AgentLink />
            }} /> {connectRequirement}</span>);
        }

		let content = (<div>
			<h2><div className="channelAdd-logo"><ChannelIcon channelDef={channelDef} size={128}/></div> {channelDef.name}</h2>

			{connectRequirement ? <p className="connect-requirement"><strong>{Tool.getLabel(type, 'connectRequirement', this.props.intl.formatMessage)}:</strong> {connectRequirement}</p> : null}

			<p><FormattedMessage defaultMessage="To connect {channelDefKey}, {productName} needs to access your data in {channelDefKey} to use them in other applications or to display results from other applications in {channelDefKey}." id="channel.grant.description1" values={{productName: config.PRODUCT_NAME, channelDefKey: channelDef.name}} /></p>
			<p><FormattedMessage defaultMessage="You do not have to create or share any credentials with {productName}. {productName} only needs to grant access for reading {channelDefKey}'s data." id="channel.grant.description2" values={{productName: config.PRODUCT_NAME, channelDefKey: channelDef.name}} /></p>
			<p><FormattedHTMLMessage defaultMessage="Before you give your consent, see <a href=&quot;{url}&quot;>how secure {productName} is</a>."  id="channel.grant.description3" values={{productName: config.PRODUCT_NAME, channelDefKey: channelDef.name, url: 'https://www.dativery.com/' + getLocale() + '/security/'}} /></p>

			{this.props.user.organisation && this.props.user.organisation.users.edges.length > 1
				? <p className="connectionNote"><strong><FormattedMessage defaultMessage="Connection note:" id="channel.connectionNote" /></strong>&nbsp;
					{channelDef.authType === AUTH_TYPE_PER_USER
						? <FormattedMessage defaultMessage="each user will have to authorize this application separately. The screen settings will be shared." id="channel.warningExplanation2.eachUser" values={{app: channelDef.name}}/>
						: <FormattedMessage defaultMessage="connected {app} will be accessible to all your connected users." id="channel.warningExplanation2.allUsers" values={{app: channelDef.name}}/>
					}
				</p>
				: null
			}

			<div>
				<LoadingButton className="btn btn-primary" onClick={this._create}><i aria-hidden="true" className="fa fa-check-circle-o"></i> <FormattedMessage defaultMessage="Grant access" id="channel.grantAccess" /></LoadingButton>
				{this.props.cancel ? <button className="btn btn-link" onClick={() => {this.props.cancel();}}><FormattedMessage defaultMessage="Cancel" id="common.cancel" /></button> : null}
			</div>
		</div>);

		if (this.props.wrapper) {
			if (this.state.showContent) {
				if (this.props.loadingStopFn) {
					this.props.loadingStopFn();
				}

				return content;
			}
			return null;
		}

        return (
            <AppPanel  breadcrumbParams={[
                {type: types['channels'], data: channel},
                {type: types['scenarios'], data: this.props.user.scenario},
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={this.props.intl.formatMessage(messages.title)}>
				<ScenarioWizard data={this.props.user} step={3} type={type}>
					{content}
				</ScenarioWizard>
            </AppPanel>
        );
    }
}


export default Relay.createContainer(wrapNotFound(injectIntl(ChannelAddStep3), (props) => {
    return props.user.organisation && props.user.organisation.channel;
}), {
    initialVariables: {
        channelId: '',
        organisationId: '',
        scenarioId: '',
        scenarioSelected: false,
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }

        variables['scenarioSelected'] = variables['scenarioId'] ? true : false;

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                scenario(id: $scenarioId) @include(if: $scenarioSelected) {
                    id,
                    realId,
					urlFragment,
                    ${ScenarioBoxAsWizard.getFragment('scenario')},
                    ${ScenarioIcon.getFragment('scenario')}
                },
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    users(first: 2) {
                        edges {
                            node {
                                id,
                                realId
                            }
                        }
                    },
                    ${ScenarioBoxAsWizard.getFragment('organisation')},
                    channel(id: $channelId) {
                        id,
                        realId,
                        organisation_id,
                        activated,
                        name,
                        channelDef {
                            id,
                            realId,
                            metadata,
                            connectRequirement,
                            requiresAgent,
                            canUseAgent,
                            name,
                            icon,
                            authType,
                        }
                    }
                },
            }
        `,
    },
});
